/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marketing_Feature_Files_NameInputs */

const en_marketing_feature_files_name = /** @type {(inputs: Marketing_Feature_Files_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Files and email`)
};

const es_marketing_feature_files_name = /** @type {(inputs: Marketing_Feature_Files_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Archivos y correo`)
};

const fr_marketing_feature_files_name = /** @type {(inputs: Marketing_Feature_Files_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fichiers et e-mail`)
};

/**
* | output |
* | --- |
* | "Files and email" |
*
* @param {Marketing_Feature_Files_NameInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" }} options
* @returns {LocalizedString}
*/
export const marketing_feature_files_name = /** @type {((inputs?: Marketing_Feature_Files_NameInputs, options?: { locale?: "en" | "es" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marketing_Feature_Files_NameInputs, { locale?: "en" | "es" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_marketing_feature_files_name(inputs)
	if (locale === "es") return es_marketing_feature_files_name(inputs)
	return fr_marketing_feature_files_name(inputs)
});